import * as Yup from 'yup'

export const InviteMCViaMessageSchema = Yup.object().shape({
  firstName: Yup.string().required('First name is required'),
  lastName: Yup.string().required('Last name is required'),
  companyName: Yup.string().required('Company name is required'),
  email: Yup.string().required('Email is required'),
})
